<template>
  <div class="col">
    <div v-if="isLoading" class="row">
      <div class="col">
        <span>loading...</span>
      </div>
    </div>
    <div v-else class="row">
      <div v-if="currentFiles.length > 0" class="col custom-file-list">
        <div v-for="(item, idx) in currentFiles" :key="idx">
          <div class="row">
            <div class="col custom-file-link">
              <a v-if="isShowFile(item)" @click="showFile(item)">
                {{ item.name }}
              </a>
            </div>
            <div class="col-2 text-right">
              <span>{{ formatDate(item.created) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="col">
        <span>No scans available</span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <span v-if="message" class="text-danger">{{ message }}</span>
    </div>
  </div>
  <DialogPreview v-model="actionPreview" @closing="closeDialog" />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { lookupStore } from '@/stores/lookup'
import DialogPreview from './DialogPreview.vue'
import globals from '@/plugins/globals'
export default {
  name: 'VehicleScans',
  components: {
    DialogPreview
  },
  data() {
    return {
      baseUrl: window.config ? window.config.apiUrl : '',
      actionPreview: null,
      mimeType: 'application/pdf',
      message: null
    }
  },
  computed: {
    ...mapState(lookupStore, ['vehicleScans', 'loading']),
    isLoading() {
      return this.loading?.vehicleScans
    },
    isLoadingScan() {
      return this.loading?.vehicleScan
    },
    currentFiles() {
      let _files = []
      if (this.vehicleScans) {
        _files = this.vehicleScans
      }
      return _files
    },
  },
  methods: {
    ...mapActions(lookupStore, ['getVehicleScans', 'getScanFile']),
    closeDialog() {
      this.actionPreview = null
    },
    isShowFile(file) {
      return file.name && file.name.length > 0
    },
    formatDate(date, type = 'datetime') {
      return globals.formatDate(date, type)
    },
    base64ToBlob(base64) {
      const binaryString = atob(base64)
      const arrayBuffer = new ArrayBuffer(binaryString.length)
      const uint8Array = new Uint8Array(arrayBuffer)
      for (let i = 0; i < binaryString.length; i++) {
        uint8Array[i] = binaryString.charCodeAt(i)
      }
      return new Blob([uint8Array], { type: this.mimeType })
    },
    async showFile(file) {
      if (!this.isLoadingScan) {
        this.actionPreview = null
        this.message = null
        console.log('Getting File', file)
        let response = await this.getScanFile(`${this.baseUrl}/blueprint${file.url}`)
        console.log('Got File i', response)
        if (response) {
          if (response.error) {
            this.message = `IW/AutoLogic Error: ${response.error}`
          } else {
            if (response.DriveSafeScanPDF === null) {
              this.message = 'No PDF content found'
              return
            } else {
              this.mimeType = 'application/pdf'
              this.height = '650px'
              const blob = this.base64ToBlob(response.DriveSafeScanPDF)
              console.log('Showing Preview')
              this.actionPreview = {
                content: URL.createObjectURL(blob),
                mimeType: this.mimeType
              }
            }
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-result-list {
  width: 100%;
  height: 550px;
  // height: 600px;
  max-height: 550px;
  overflow-x: hidden;
  overflow-y: scroll;
  padding-top: 15px;
}

.custom-list {
  list-style-type: none;

  li {
    padding: 5px;
  }

  li:hover {
    background-color: rgb(219, 219, 219);
    cursor: pointer;
  }
}

.custom-list-item {
  div {
    width: 100%;
    font-size: 0.8em;
    font-weight: 500;
    margin-bottom: 8px;
  }
}

.custom-file-list {
  overflow-x: hidden;
  overflow-y: scroll;
  max-height: 600px;
  height: 100%;
  width: 100%;
  margin-right: 15px;
}

.custom-file-link {
  cursor: pointer;
  display: flex;
  align-items: left;

  a {
    padding: 10px;
    width: 100%;
  }
}
</style>